import PageContainer from "../../components/container/PageContainer";

export default function Report() {
    return(
        <PageContainer>
            Report
        </PageContainer>
    )
}